
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[category]/[slug]",
      function () {
        return require("private-next-pages/p/[category]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[category]/[slug]"])
      });
    }
  